import {
  ActionTitle,
  type ActionTitleProps,
} from "@/components/actionTitle/ActionTitle";
import { Text } from "@repo/skapa";
import { PaddedContainer } from "@repo/ui";
import { type ComponentPropsWithoutRef, type PropsWithChildren } from "react";

type SectionItemProps = ComponentPropsWithoutRef<"div"> &
  PropsWithChildren &
  ActionTitleProps;

export const SectionItemEmptyState = ({ title }: { title: string }) => (
  <Text>{title}</Text>
);

export const SectionItem = ({
  title,
  action,
  children,
  id,
}: SectionItemProps) => {
  return (
    <PaddedContainer id={id}>
      <ActionTitle title={title} action={action} />
      {children}
    </PaddedContainer>
  );
};
